import { ReactElement, useCallback, type FC } from 'react';

import { MessageInput } from '@pp/core/src/components/chat/messageInput/MessageInput';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { chatCommunicationController } from '@pp/core/src/controllers/chatCommunication/ChatCommunicationControllerConnector';
import { generateMessage } from '@pp/core/src/utils/chat';

import styles from './ChatFooter.module.css';

export interface ChatFooterProps {
  casinoId: string;
  dealerName: string;
  isBetRequiredToChat: boolean;
  isGameChat: boolean;
  isGameChatBlocked: boolean;
  isGameChatUnavailable: boolean;
  isLiveSupportChatBlocked: boolean;
  isMiniChat: boolean;
  tableId: string;
  userId: string;
  cashierCallback?: () => void;
}

export const ChatFooter: FC<ChatFooterProps> = ({
  cashierCallback,
  casinoId,
  dealerName,
  isBetRequiredToChat,
  isGameChat,
  isGameChatBlocked,
  isGameChatUnavailable,
  isLiveSupportChatBlocked,
  isMiniChat,
  tableId,
  userId,
}): ReactElement => {
  const audioTrigger = useAudioTrigger();

  const handleSendMessage = useCallback(
    (input: string) => {
      if (input.trim() !== '') {
        audioTrigger.play({ name: 'menuClick' });
        // Send message to chat server via websocket
        chatCommunicationController.sendMessage(
          JSON.stringify(generateMessage(userId, input, tableId, casinoId, isGameChat))
        );
      }
    },
    [audioTrigger, casinoId, isGameChat, tableId, userId]
  );

  return (
    <div className={styles.chatFooter}>
      <MessageInput
        cashierCallback={cashierCallback}
        isBetRequiredToChat={isBetRequiredToChat}
        isGameChat={isGameChat}
        isGameChatBlocked={isGameChatBlocked}
        isGameChatUnavailable={isGameChatUnavailable}
        isLiveSupportChatBlocked={isLiveSupportChatBlocked}
        isMiniChat={isMiniChat}
        onSubmit={handleSendMessage}
      />
    </div>
  );
};
